/**
 * UI adapter: probabilistic random events in tick frame
 */
import type { RandomEvent } from '../../../../types';
import { RANDOM_EVENTS } from '../../../../constants';
import { architectureFeatures } from '../../../infrastructure/config/features';
import { triggerRandomEventUseCase } from '../../../infrastructure/di/container';
import { TriggerRandomEventUseCase } from '../../../application/use-cases/TriggerRandomEventUseCase';
import type { TriggerRandomEventOutput } from '../../../application/use-cases/TriggerRandomEventUseCase';

export interface ResolveRandomEventInput {
  eventActive: boolean;
  compliance: number;
  threat: number;
  loanCount: number;
  gateRoll?: number;
  pickRoll?: number;
  events?: RandomEvent[];
}

export function resolveTriggerRandomEvent(
  input: ResolveRandomEventInput,
): TriggerRandomEventOutput {
  const payload = {
    ...input,
    events: input.events ?? RANDOM_EVENTS,
  };

  if (architectureFeatures.useRandomEventUseCase) {
    return triggerRandomEventUseCase.execute(payload);
  }
  return new TriggerRandomEventUseCase().execute(payload);
}